/* eslint-disable jira/filename-case */
import type { StoreState } from '../types.tsx';
import shallowEqual from '../utils/shallow-equal.tsx';

const updateMiddleware =
	<TState,>(storeState: StoreState<TState>) =>
	(next: Function) =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(arg: any): undefined => {
		let output;
		const state = storeState.getState();
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const nextState = next(state, arg, (out: any) => {
			output = out;
		});
		if (!shallowEqual(nextState, state)) {
			storeState.setState(nextState);
		}
		return output;
	};

export default updateMiddleware;
